import { useCallback, useState } from "react";

import { useLoyaltyPrograms, useSwitchLoyaltyProgramStatus } from "features/LoyaltyPackage/data/hooks";
import { LOYALTY_PACKAGE_STATUS } from "features/LoyaltyPackage/core/constants";
import useDebounce from "hooks/useDebounce";

export default function useProgramList() {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 500);

  const [pagination, setPagination] = useState({ limit: 10, offset: 0 });

  const filters = debouncedSearch ? { title: debouncedSearch } : undefined;

  const { data, loading, refetch } = useLoyaltyPrograms(filters, pagination);

  const listRefetch = useCallback(() => refetch({ fetchPolicy: "network-only" }), [refetch]);

  const { switchStatus, loading: switchLoading } = useSwitchLoyaltyProgramStatus();

  const programs = data?.loyaltyPackages ?? [];
  const paginationData = data?.paginationData ?? { total: 0, offset: 0, limit: 10 };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPagination((prev) => ({ ...prev, offset: 0 }));
  };

  const handleTableChange = (antPagination) => {
    const { current, pageSize } = antPagination;
    setPagination({ limit: pageSize, offset: (current - 1) * pageSize });
  };

  const handleSwitchStatus = async (record, checked) => {
    await switchStatus(record.id, checked);
  };

  const isEditable = (record) => record.status === LOYALTY_PACKAGE_STATUS.UPCOMING;

  return {
    searchTerm,
    handleSearch,
    programs,
    paginationData,
    loading,
    switchLoading,
    handleTableChange,
    handleSwitchStatus,
    isEditable,
    pagination,
    filters,
    refetch,
    listRefetch,
  };
}
